/**
 * @file Welcomeメッセージコントロール
 *
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname ControlWelcomeMessage
 * @classdesc Welcomeメッセージコントロール
 */
export default class ControlWelcomeMessage {
	/**
	 * @constructor
	 * @param {jQuery} $e - .page-select-favorite-shop
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		const shopSelected = window.localStorage.getItem('_cfs_') || null;
		if(!shopSelected){
			$('#header').hide();
			$('#footer').hide();
			$('.aside--breadcrumb').hide();
			$('.heading--section-title').hide();
		}else{
			$('#welcome').hide();
		}
	};
};
